import React, { createContext, useContext, useState } from 'react';

const TitularContext = createContext({});

export function useTitular() {
    const context = useContext(TitularContext);

    return context;
}

export function TitularProvider({ children }) {
    const [dataContrato, setDataContrato] = useState({});
    const [dataTitular, setDataTitular] = useState({});
    const [othersDocuments, setOthersDocuments] = useState([]);
    const [flow, setFlow] = useState(null);
    const [alerts, setAlerts] = useState([]);

    function clearTitular() {
        setDataTitular({});
        setOthersDocuments([]);
        setDataContrato({});
    }

    function clearAlerts() {
        setAlerts([]);
    }

    return (
        <TitularContext.Provider
            value={{
                dataContrato,
                setDataContrato,
                dataTitular,
                setDataTitular,
                clearTitular,
                flow,
                setFlow,
                othersDocuments,
                setOthersDocuments,
                alerts,
                setAlerts,
                clearAlerts,
            }}
        >
            {children}
        </TitularContext.Provider>
    );
}
